import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styles from './Article.module.sass';
import arrow from '../../../../../images/icons/small-arrow-right.svg';
import dateToMonthAndYear from '../../../services/date_service';

class Article extends Component {
  componentDidMount() {
    window.lazyLoad.update();
  }

  render() {
    const { article, className, lazyLoad } = this.props;
    const {
      title, media_name: mediaName, link, background_image_url: image,
    } = article;
    const publishedAt = dateToMonthAndYear(new Date(article.published_at));

    const imageProps = lazyLoad ? { className: 'lazyload', 'data-src': image } : { src: image };

    return (
      <a
        href={link}
        rel="nofollow noopener noreferrer"
        target="_blank"
        className={`${styles.article} ${className} ${image && styles['no-border']}`}
      >
        <div className={styles.background}>
          { image && (
            <img {...imageProps} alt="background" />
          )}
        </div>
        <div className={styles['media-name']}>
          {mediaName}
        </div>
        <div className={styles.date}>
          {publishedAt}
        </div>
        <div className={styles.title}>
          {title}
        </div>
        <div className={styles.link}>
          <div className={styles.row}>
            Read Article
            <img src={arrow} alt="arrow" />
          </div>
        </div>
      </a>
    );
  }
}

Article.propTypes = {
  article: PropTypes.shape({
    media_name: PropTypes.string,
    title: PropTypes.string,
    link: PropTypes.string,
    published_at: PropTypes.string,
    background_image_url: PropTypes.string,
  }).isRequired,
  className: PropTypes.string,
  lazyLoad: PropTypes.bool,
};

Article.defaultProps = {
  className: '',
  lazyLoad: true,
};

export default Article;
